import { Extension } from '@tiptap/core';
import { PluginKey } from '@tiptap/pm/state';
import Suggestion from '@tiptap/suggestion';
import { VueRenderer } from '@tiptap/vue-3';
import { COMPONENTS, insertComponent } from '@/components/writer/catalog.js';
import SlashMenu from '@/components/writer/SlashMenu.vue';

/** Typing "/" on a line lists the components. */
export const SlashCommands = Extension.create({
  name: 'slashCommands',

  addProseMirrorPlugins() {
    return [Suggestion({
      editor: this.editor,
      char: '/',
      startOfLine: true,
      pluginKey: new PluginKey('slashCommands'),
      items: ({ query }) => {
        const q = query.toLowerCase();
        return COMPONENTS.filter((c) => `${c.label} ${c.hint} ${c.key}`.toLowerCase().includes(q));
      },
      command: ({ editor, range, props }) => insertComponent(editor, props, range),
      render: () => {
        let menu = null;
        const place = (clientRect) => {
          const rect = clientRect?.();
          if (!rect || !menu?.element) return;
          const below = rect.bottom + 8 + 360 < window.innerHeight;
          Object.assign(menu.element.style, {
            position: 'fixed',
            zIndex: 60,
            left: `${Math.max(8, Math.min(rect.left, window.innerWidth - 328))}px`,
            top: below ? `${rect.bottom + 8}px` : `${Math.max(8, rect.top - 368)}px`,
          });
        };
        return {
          onStart(props) {
            menu = new VueRenderer(SlashMenu, { props, editor: props.editor });
            document.body.appendChild(menu.element);
            place(props.clientRect);
          },
          onUpdate(props) {
            menu?.updateProps(props);
            place(props.clientRect);
          },
          onKeyDown(props) {
            if (props.event.key === 'Escape') return false;
            return menu?.ref?.onKeyDown(props.event) ?? false;
          },
          onExit() {
            menu?.element?.remove();
            menu?.destroy();
            menu = null;
          },
        };
      },
    })];
  },
});
